import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit'
import { client } from '../../api/client'

const supervisorsAdapter = createEntityAdapter({
    selectId: x => x.Id
})

const initialState = supervisorsAdapter.getInitialState({
    status: 'idle',
    error: null,
})

export const fetchSupervisors = createAsyncThunk('supervisors/Get', async () => {
    const response = await client.get('/Supervisors')
    return response.data
})

export const fetchSupervisorById = createAsyncThunk('supervisors/GetById', async (objId) => {
    const response = await client.get('/Supervisors/' + objId)
    return response.data
})

const supervisorsSlice = createSlice({
    name: 'supervisors',
    initialState,
    reducers: {},
    extraReducers: {
        [fetchSupervisors.pending]: (state, action) => {
            state.status = 'loading'
            state = undefined
        },
        [fetchSupervisors.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            supervisorsAdapter.addMany(state, action.payload)
        },
        [fetchSupervisors.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload
        },
        [fetchSupervisorById.pending]: (state, action) => {
            state.status = 'loading'
            state = undefined
        },
        [fetchSupervisorById.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            supervisorsAdapter.addOne(state, action.payload)
        },
        [fetchSupervisorById.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload
        }
    },
})

export default supervisorsSlice.reducer

export const {
    selectAll: selectAllSupervisors,
    selectById: selectSupervisorById,
} = supervisorsAdapter.getSelectors((state) => state.supervisors)
